import React, { useState, useEffect } from 'react';
import './index.scss';

const Maintenance = () => {
    // 维护结束时间：2026年1月20日 20:00:00
    const endTime = new Date('2026-01-20T20:00:00').getTime();
    
    const [timeLeft, setTimeLeft] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = endTime - now;

            if (distance > 0) {
                setTimeLeft({
                    hours: Math.floor(distance / (1000 * 60 * 60)),
                    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((distance % (1000 * 60)) / 1000)
                });
            } else {
                // 维护结束，刷新页面
                window.location.reload();
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [endTime]);

    const padZero = (num) => String(num).padStart(2, '0');

    return (
        <div className="maintenance-container">
            <div className="maintenance-content">
                <div className="maintenance-icon">🔧</div>
                <h1 className="maintenance-title">系统升级维护中</h1>
                <p className="maintenance-desc">
                    为了给您提供更好的服务体验，我们正在进行系统升级
                </p>
                
                <div className="maintenance-time">
                    <div className="time-label">预计恢复时间</div>
                    <div className="time-value">1月20日 晚上 20:00</div>
                </div>

                <div className="countdown">
                    <div className="countdown-label">距离恢复还有</div>
                    <div className="countdown-timer">
                        <div className="countdown-item">
                            <span className="countdown-number">{padZero(timeLeft.hours)}</span>
                            <span className="countdown-unit">小时</span>
                        </div>
                        <span className="countdown-separator">:</span>
                        <div className="countdown-item">
                            <span className="countdown-number">{padZero(timeLeft.minutes)}</span>
                            <span className="countdown-unit">分钟</span>
                        </div>
                        <span className="countdown-separator">:</span>
                        <div className="countdown-item">
                            <span className="countdown-number">{padZero(timeLeft.seconds)}</span>
                            <span className="countdown-unit">秒</span>
                        </div>
                    </div>
                </div>

                <div className="maintenance-notice">
                    <p>💡 温馨提示：维护期间数据不会丢失，请耐心等待</p>
                </div>

                <div className="maintenance-wukong">
                    <div className="wukong-animation">🐵</div>
                    <p>悟空正在努力升级中...</p>
                </div>
            </div>
        </div>
    );
};

export default Maintenance;

